import React from 'react';
import { FaPenFancy } from 'react-icons/fa';
 
export const TermsConditions = ({ setActiveTab, activeTab }) => {
  return (
    <>
      <li className="nav-item">
        <button
          className={`nav-link ${activeTab === 'termsConditions' ? 'active' : ''}`}
          onClick={() => setActiveTab('termsConditions')}
        >
              <span style={{  marginRight: '10px', fontSize: '20px' }}> <FaPenFancy /> </span>
          Terms & Conditions Settings
        </button>
      </li>
    </>
  );
};